import { Col, Typography } from 'antd';
import styled from 'styled-components';

export const StatusText = styled(Typography.Text)``;

export const Text = styled(Typography.Text)``;

export const FilterCol = styled(Col)`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
